import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=6e37b986&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=6e37b986&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37b986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e37b986')) {
      api.createRecord('6e37b986', component.options)
    } else {
      api.reload('6e37b986', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=6e37b986&scoped=true", function () {
      api.rerender('6e37b986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cas/ResetPassword.vue"
export default component.exports